import { createAuth0 } from '@auth0/auth0-vue';

import mockAuth0Plugin from './mockAuth0Plugin';

const auth0 = createAuth0(
  {
    domain: import.meta.env.VUE_APP_AUTH_DOMAIN,
    clientId: import.meta.env.VUE_APP_AUTH_CLIENT_ID,
    authorizationParams: {
      audience: import.meta.env.VUE_APP_AUTH_AUDIENCE,
      redirect_uri: `${
        !import.meta.env.SSR ? window.location.origin : import.meta.env.VUE_APP_BASE_URL
      }/en/my-ads/login-callback`,
    },
    useRefreshTokens: true,
    useRefreshTokensFallback: true,
    sessionCheckExpiryDays: 365, // Maximum session lifetime
  },
  {
    skipRedirectCallback: true,
  },
);

// Load the mock plugin for running UI tests and for SSG
export default import.meta.env.VUE_APP_MOCK_AUTH === 'ui-tests' || import.meta.env.SSR
  ? mockAuth0Plugin
  : auth0;
